import {configureStore} from '@reduxjs/toolkit';
import commonReducer from './modules/common.slice';

export const store = configureStore({
  reducer: {
    common: commonReducer,
  },
});
